var map = {
	"./9_g28lpOXL.jpeg": 39903,
	"./IMG_20210520_080914.jpg": 12414,
	"./IMG_20220103_080937.jpg": 2131,
	"./IMG_20220421_182158.jpg": 44783,
	"./VID_20220524_220523.mp4": 73311,
	"./image.jpg": 96532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31583;